import { render, staticRenderFns } from "./outputBasicData.vue?vue&type=template&id=64af3990&scoped=true&"
import script from "./outputBasicData.vue?vue&type=script&lang=js&"
export * from "./outputBasicData.vue?vue&type=script&lang=js&"
import style0 from "./outputBasicData.vue?vue&type=style&index=0&id=64af3990&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af3990",
  null
  
)

export default component.exports